export default {"src":"/_next/static/image/public/images/error_book.89235fffe0f30f5cbd78965d550cd130.svg","height":158,"width":178};